import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoriesComponent } from './stories.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { StoryPageComponent } from './story-page/story-page.component';
import { StoryPageModule } from './story-page/story-page.module';
import { MatButtonModule } from '@angular/material/button';
import { StoryTitleModule } from '../../../shared/components/story-title/story-title.module';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';

const ANGULAR_MATERIAL_MODULES = [
  MatButtonModule, MatSelectModule, MatChipsModule
];

const COMPONENTS = [StoriesComponent];

export const publicStories_nav_path = {};

const routes: Routes = [
  { path: '', component: StoriesComponent, pathMatch: 'full' },
  { path: ':storyID', component: StoryPageComponent }
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    RouterModule.forChild(routes), CommonModule, StoryPageModule,
    ...ANGULAR_MATERIAL_MODULES, SharedModule, StoryTitleModule
  ],
  exports: [RouterModule, ...COMPONENTS]
})
export class PublicStoriesModule { }
